import { CSSProperties, Fragment } from "react";
import { PhaseTagStyled } from "./PhaseTag.styled";

type TPhaseTagProps = {
  phaseIndex?: number;
  style?: CSSProperties;
  phaseNumber?: number;
};

function getPhaseStyle(phaseIndex?: number) {
  switch (phaseIndex) {
    case 0:
      return {
        color: "var(--color-white)",
        backgroundColor: `#40A9FF`,
      };

    case 1:
      return {
        color: "#000000D9",
        backgroundColor: "#FADB14",
      };

    default:
      return {
        color: "var(--color-white)",
        backgroundColor: `var(--color-primary)`,
      };
  }
}

function getPhaseText(phaseNumber?: number) {
  if (typeof phaseNumber === "number") {
    return `アンケート結果（${phaseNumber}回目）`;
  }

  return "アンケート結果";
}

function PhaseTag(props: TPhaseTagProps) {
  const { phaseNumber, style } = props;

  if (typeof phaseNumber !== "number") return <Fragment />;

  const extendStyle = getPhaseStyle(phaseNumber);
  const phaseLabel = getPhaseText(phaseNumber);

  return (
    <PhaseTagStyled style={{ ...extendStyle, ...style }}>
      {phaseLabel}
    </PhaseTagStyled>
  );
}

export { PhaseTag };
